import React, { useEffect, ReactNode } from "react";
import Modal from 'react-modal';
import { Typography } from "antd";
import HeaderText from "./HeaderText";
import "../css/modal.css";
import { isEmpty } from "lodash";

interface WelcomeModalProps {
  children: ReactNode;
  onClose: () => void;
  isVisible: boolean;
  modalHeaderText: string;
  modalSubHeaderText: string;
}

const customStyles: ReactModal.Styles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height: '70%',
    width: '36%',
    backgroundColor: 'white',
    boxShadow: '1px 2px 14px -2px rgba(0,0,0,0.75)',
    borderRadius: 20,
    borderColor: '#D3D3D3',
    borderWidth: '2px',
    overflow: 'hidden',
    padding: '0',
    paddingRight: '0'
  },
};

const contentWrapperStyles: React.CSSProperties = {
  height: '100%',
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
};

const WelcomeModal: React.FC<WelcomeModalProps> = ({
  children,
  onClose,
  isVisible,
  modalHeaderText,
  modalSubHeaderText,
}) => {
  useEffect(() => {
    const scrollbarStyle = document.createElement('style');
    scrollbarStyle.innerHTML = `
      .modal-content-wrapper::-webkit-scrollbar {
        width: 0rem;
      }
      .modal-content-wrapper::-webkit-scrollbar-track {
        background-color: transparent;
      }
      .modal-content-wrapper::-webkit-scrollbar-thumb {
        background-color: transparent;
      }
    `;
    document.head.appendChild(scrollbarStyle);

    return () => {
      document.head.removeChild(scrollbarStyle);
    };
  }, []);

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="modal-content-wrapper" style={contentWrapperStyles}>
        <div style={{ marginBottom: 10 }}>
          <div onClick={onClose} style={{ cursor: 'pointer',display:'flex',flex:1,justifyContent:'flex-end', alignItems:'flex-end',paddingRight:10}}>
              <text style={{ fontSize: 25, color: 'black', fontWeight: '500' }}>x</text>
          </div>
        </div>
        <div style={{ padding: '0 25px 0 25px' }}>
          {children}
        </div>
      </div>
    </Modal>
  );
}

export default WelcomeModal;
